import React from 'react';
import { BookOpen, Clock, ShoppingCart, CheckSquare } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-green-600" data-id="element-222" />,
    title: 'Guía Principal: El Código de la Longevidad Metabolismo 55+',
    description: 'El manual completo para entender y aplicar el método.'
  }, {
    icon: <Clock className="w-8 h-8 text-green-600" data-id="element-223" />,
    title: 'El Protocolo de 24 Horas',
    description: 'Su hoja de ruta diaria desde que despierta hasta que duerme.'
  }, {
    icon: <ShoppingCart className="w-8 h-8 text-green-600" data-id="element-224" />,
    title: 'Lista de Compras USA',
    description: "Qué comprar y qué evitar en Walmart, Costco y Sedano's."
  }, {
    icon: <CheckSquare className="w-8 h-8 text-green-600" data-id="element-225" />,
    title: 'Checklist de Re-encendido',
    description: 'Para monitorear su progreso y niveles de energía cada mañana.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-226">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="max-w-4xl mx-auto" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-229">
            Todo lo que recibe hoy
          </h2>

          <div className="grid sm:grid-cols-2 gap-8" data-id="element-230">
            {items.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-231">
                <div className="bg-green-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-232">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-233">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-234">
                  {item.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}